import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { BankTransferTemplate } from 'components/Templates'

const BankTransfer: FC = () => {
  return (
    <Layout headline={'銀行振込'} iconPath={'/icon/white/revenue.svg'} title={'銀行振込'}>
      <BankTransferTemplate />
    </Layout>
  )
}

export default BankTransfer
